import { useQuery } from 'react-query'
import { getUniteCatalogItem } from '../FormResponsePage/sections/ProductSection/hooks/useCatalogSearchService'

export default function useUniteDetails(itemId?: string) {
  const item = useQuery(['catalogItem', itemId], () => getUniteCatalogItem(itemId || ''), { enabled: !!itemId })

  return { item }
}
